var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headers"},[_c('headers')],1),_vm._v(" "),_c('div',{staticClass:"msgBox flexbox"},[_c('div',{staticClass:"msgLeft"},[_c('navs')],1),_vm._v(" "),_c('div',{staticClass:"msgRight",style:({height:_vm.mainHeight-2+'px'})},[_c('div',[_c('router-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-043fbee2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/$index.old.vue
// module id = null
// module chunks = 